import React from 'react';
import { LinkingAttemptsProvider } from 'Components/AdvisorApp/Viewport/LinkingAttempts/LinkingAttemptsContext';
import LinkingAttemptsContent from 'Components/AdvisorApp/Viewport/LinkingAttempts/LinkingAttemptsContent';
import useUserContext from 'Context/UserContext';

const LinkingAttempts = () => {
  const { agentResource } = useUserContext();

  return (
    <LinkingAttemptsProvider agentResource={agentResource}>
      <LinkingAttemptsContent />
    </LinkingAttemptsProvider>
  );
};

LinkingAttempts.defaultProps = {};

LinkingAttempts.propTypes = {};

export default LinkingAttempts;
